/*
 * @description: 表单重置指令 对element-Ui 的el-form元素做表单值清空
 * @author: zb
 * @update: zb
 * @param form-ref-name   表单元素的引用
 * @LastEditors: zb
 * @Date: 2019-04-25 20:36:28
 * @LastEditTime: 2019-05-17 10:41:22
 */

'use strict'
const formResetDirective = function(el, binding, vnode) {
  el.addEventListener('click', function(e) {
    vnode.context.$refs[binding.arg].resetFields()
  })
}
// const formResetDirective = Object.create(Object.prototype, {
//   // 指令的定义
//   'form-reset': {
//     value: func,
//     configurable: true,
//     writable: true,
//     enumerable: true
//   }
// })

export default formResetDirective
